module.exports = __webpack_public_path__ + "img/Slots.598588e2.png";